import Form, { Field, OnChange, OnSubmit, Submit } from '@basementcrowd/react-form'
import dayjs from 'dayjs'
import { FC, useState } from 'react'
import { checkboxInputClasses, textInputClasses } from '../formStyles'

const attachedDataMailBody = `Please find the details of users that should be deleted attached to this email.

Thanks,
`
const padder = (inputStr: string, targetLength: number = 30): string => {
  let output = inputStr.trimEnd()
  for (let i = output.length; i < targetLength; i++) {
    output += ' '
    if (i % 2 !== 0) {
      output += ' ' // Some goofiness to space things better
    }
  }
  return output
}

interface FormEntries {
  companyName: string
  [k: string]: string | boolean
}

const DeletePage: FC = () => {
  const [userCount, setUserCount] = useState<number>(1)

  const [initialValues, setInitialValues] = useState<FormEntries>({ companyName: '', 'user.0.name': '', 'user.0.email': '', 'user.0.leftFirm': false })

  const mailToLinkAttach = encodeURI(
    `mailto:user-admin@fromcounsel.com?subject=Deletion Request ${dayjs().format('DD/MM/YY')}&body=${attachedDataMailBody}`
  )

  const handleSubmit: OnSubmit<FormEntries> = (e, { values, onFinishSubmit }) => {
    e.preventDefault()
    let emailBody = 'The following is the list of ' + values.companyName + ' users to be deleted:%0D%0A%0D%0A'
    emailBody += `${padder('Name')}|${padder(' Email')}| Left firm?%0D%0A`
    emailBody += '––––––––––––––––––––––––|––––––––––––––––––––––––|––––––––––––––––––––––––%0D%0A'
    for (let i = 0; i < userCount; i++) {
      const entry = `${padder(values[`user.${i}.name`].toString())} | ${padder(' ' + values[`user.${i}.email`].toString())} | ${values[`user.${i}.leftFirm`] === true ? 'Yes' : 'No'}%0D%0A`
      emailBody += entry
    }

    emailBody += '%0D%0AThanks,'
    document.location.href = `mailto:user-admin@fromcounsel.com?subject=Deletion Request ${dayjs().format('DD/MM/YY')}&body=${emailBody}`
    onFinishSubmit()
  }

  const handleChange: OnChange<FormEntries> = (values, field) => {
    if (field === undefined) return
    setInitialValues({
      ...initialValues,
      [field]: values[field]
    })
  }

  return (
    <section className='layout-width-constraint'>
      <div className='ph8'>
        <h1>Delete Users</h1>
        <p>You may either complete this form with the details of the users you wish to remove, or click "Use Spreadsheet".</p>
        <p>If you click "Use Spreadsheet" it will create an email for you to send to us, which you should attach the spreadsheet to.</p>
        <a
          className='bg-teal white pv3 ph5 ba b--transparent no-underline br2 normal f6 lh-copy-variant hover-o-90 pointer'
          href={mailToLinkAttach}
        >
          Use Spreadsheet
        </a>
        <p>If you fill in the form, when you click submit it will generate the email for you with the details provided which you just need to press send on.</p>
        <div>
          <Form<FormEntries>
            initialValues={{ ...initialValues }}
            onChange={handleChange}
            onSubmit={handleSubmit}
            dynamic
          >
            <Field
              type='text'
              label='Company Name'
              name='companyName'
              classes={textInputClasses}
            />
            {
              [...Array(userCount)].map((_, idx) => (
                <div key={idx} className='pt6'>
                  <div className='fl b'>User {idx + 1}</div>
                  <div key={idx} className='flex'>
                    <div className='mr6'>
                      <Field
                        type='text'
                        label='Name'
                        name={`user.${idx}.name`}
                        classes={textInputClasses}
                      />
                    </div>
                    <div className='mr6'>
                      <Field
                        type='text'
                        label='Email'
                        name={`user.${idx}.email`}
                        classes={textInputClasses}
                      />
                    </div>
                    <Field
                      type='checkbox'
                      label='Left Firm?'
                      name={`user.${idx}.leftFirm`}
                      classes={checkboxInputClasses}
                    />
                  </div>
                </div>
              ))
            }
            <div className='flex mt6'>
              <button
                className='mr6 bg-indian-red white pv3 ph5 ba b--transparent no-underline br2 normal f6 lh-copy-variant hover-o-90 pointer'
                disabled={userCount === 1}
                onClick={() => {
                  const newUserCount = Math.max(1, userCount - 1)
                  setUserCount(newUserCount)
                  const entries = Object.entries(initialValues).filter(([k]) => !k.startsWith(`user.${newUserCount}.`))
                  setInitialValues(Object.fromEntries(entries) as FormEntries)
                }}
                type='button'
              >
                Remove User
              </button>
              <button
                className='bg-dark-sea-green white pv3 ph5 ba b--transparent no-underline br2 normal f6 lh-copy-variant hover-o-90 pointer'
                onClick={() => {
                  setUserCount(userCount + 1)
                  setInitialValues({
                    ...initialValues,
                    [`user.${userCount}.name`]: '',
                    [`user.${userCount}.email`]: '',
                    [`user.${userCount}.leftFirm`]: false
                  })
                }}
                type='button'
              >
                Add User
              </button>
            </div>
            <Submit
              className='mt8 bg-teal white pv3 ph5 ba b--transparent no-underline br2 normal f6 lh-copy-variant hover-o-90 pointer'
              value=''
            >
              Submit
            </Submit>
          </Form>
        </div>
      </div>
    </section>
  )
}

export default DeletePage
